// Auto-generated normalizer for table: ExamenPreguntaOpcionMultiple
export function examenPreguntaOpcionMultipleNormalize(row) {
  return {
    idExamenRespuestaOpcionMultiple: row.idExamenRespuestaOpcionMultiple ?? row.IdExamenRespuestaOpcionMultiple ?? row['IdExamenRespuestaOpcionMultiple'] ?? 0,
    idExamenPregunta: row.idExamenPregunta ?? row.IdExamenPregunta ?? row['IdExamenPregunta'] ?? 0,
    permiteMultiple: row.permiteMultiple ?? row.PermiteMultiple ?? row['PermiteMultiple'] ?? false,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
